import { Tab } from 'semantic-ui-react';
import { getPaneCfg } from '../../../../utils/general';
import EntityTaskExecutionsTable from './entityTaskExecutionsTable';
import { TASK_STATUS, TASK_STATUSES } from '../../../../constnats/task';

function EntityTaskExecutions({ entityId }: { entityId: number }) {
    const panes = [
        getPaneCfg(
            'Active',
            <EntityTaskExecutionsTable
                entityId={entityId}
                statuses={TASK_STATUSES.filter((s) => s !== TASK_STATUS.COMPLETED)}
                showTableActions
            />
        ),
        getPaneCfg('Completed', <EntityTaskExecutionsTable entityId={entityId} statuses={[TASK_STATUS.COMPLETED]} />),
    ];

    return <Tab panes={panes} />;
}

export default EntityTaskExecutions;
